<div class="enabled-users">
  <h3>Usuários ({{ numberOfUsers }})</h3>
  <div class="filter-input">
    <mat-icon>search</mat-icon>
    <input type="text" [(ngModel)]="filterName" placeholder="Filtrar por usuário" />
  </div>
  <div class="table">
    <div class="empty" *ngIf="isEmpty">
      NÃO HÁ OPERADORES DISPONÍVEIS NESSE MOMENTO.
    </div>

    <div class="header" *ngIf="!isEmpty">
      <mat-checkbox (change)="allChecked($event.checked)" [checked]="isAllChecked"></mat-checkbox>
      <div class="available column">Online/Offline</div>
      <div class="user column">Usuário</div>
      <div class="device column">Dispositivo</div>
    </div>

    <div class="item-list" *ngIf="!isEmpty">
      <div class="item" *ngFor="let user of filteredUsers" [ngClass]="{'primary-bg': usersHighlighted.includes(user.id)}">
        <mat-checkbox [value]="user.id" [checked]="isAllChecked || usersHighlighted.includes(user.id)" (change)="onCheckboxChange($event)"></mat-checkbox>
        <div class="available column">
          <span class="avail-dot" aria-hidden="true"
              [ngClass]="{'on': user.online, 'off': !user.online}">
          </span>
        </div>
        <div class="user column">
          {{ user.username }}
        </div>
        <div class="device column">{{ user.currentDevice || '---' }}</div>
      </div>
    </div>
  </div>
</div>
